// Collapse prevent close data attribute
// Author: Wakefly
// Purpose: To prevent Bootstrap collapse toggles from closing (collapsing) its collapse target on click, apply this data attribute.
document.addEventListener('DOMContentLoaded', () => {
  // When collapse toggle element with [data-collapse-toggle-prevent-close="true"] is clicked
  // and the collapse target is already open, then don't close the collapse target
  document.querySelectorAll('[data-wf-collapse-toggle-prevent-close="true"]').forEach((elem) => {
    let collapseElement = document.querySelector(elem.getAttribute('data-bs-target') || elem.getAttribute('href'));
    elem.addEventListener('click', (evt) => {
      elem.classList.remove('collapsed')
      collapseElement.classList.add('show')
    })
  })
})